import type { Pagination, StandardDrink } from '@barboxx/models/types';

import { api } from '../../api';

const rootPath = 'standard-drinks';

export function getStandardDrinks(query: StandardDrink.SearchQuery) {
    return api.get<Pagination<StandardDrink>>(`${rootPath}`, query);
}

export function getStandardDrink(id: number) {
    return api.get<StandardDrink.DetailsResponse>(
        `${rootPath}/${id}`,
        undefined
    );
}

export function postStandardDrink(data: StandardDrink.CreateRequest) {
    return api.post<StandardDrink>(`${rootPath}`, data);
}

export function putStandardDrink(
    id: number,
    data: StandardDrink.UpdateRequest
) {
    return api.put<StandardDrink>(`${rootPath}/${id}`, data);
}

export function deleteStandardDrink({ id }: StandardDrink.DeleteRequest) {
    return api.delete(`${rootPath}/${id}`, undefined);
}
